export const baseTranslationsEs = {
  app: "Aplicación",
  home: "Página de inicio",
  login: "Iniciar sesión",
  logout: "Cerrar sesión",
  user: "Usuario",
  none: "Ninguno",
  language: "Idioma",
  role: "Rol",
  roles: "Roles",
  username: "Nombre de usuario",
  email: "Correo electrónico",
  firstname: "Nombre",
  lastname: "Apellido",
  addUser: "Añadir usuario",
  editUser: "Editar usuario",
  password: "Contraseña",
  forgotPassword: "¿Olvidó su contraseña?",
  loginErrorTitle: "Error de inicio de sesión",
  loginEmailError: "Este nombre de usuario no está asociado a ninguna cuenta",
  loginError: "Credenciales de usuario no válidas",
  loginPassword: "Contraseña incorrecta",
  userManagement: "Gestión de usuarios",
  genericError:
    "Se ha producido un error. Inténtelo de nuevo dentro de unos minutos o póngase en contacto con el administrador del sistema.",
  search: "Buscar",
  save: "Guardar",
  cancel: "Cancelar",
  unchanged: "Sin cambios",
  parameters: "Parámetros",
  oneWeek: "Una semana",
  oneMonth: "Un mes",
  twoMonth: "Dos meses",
  threeMonth: "Tres meses",
  sixMonth: "Seis meses",
  dragAndDopProperty: "Arrastre y suelte un parámetro para mostrar su gráfico",
  addFile: "Añadir archivo",
  name: "Nombre",
  type: "Tipo",
  startDate: "Fecha de inicio",
  endDate: "Fecha de finalización",
  actions: "Acciones",
  delete: "Eliminar",
  confirmDelete: "Confirmar eliminación",
  error: "Error",
  status: "Estado",
  page: "Página",
  close: "Cerrar",
  correlation: "Correlación",
  covariance: "Covarianza",
  selectedDateRange: "Intervalo de fechas seleccionado",
  min: "Mín.",
  max: "Máx.",
  mean: "Media",
  tendency: "Tendencia",
  offset: "Desfase",
  weeks: "Semana | Semanas",
  years: "Año | Años",
  months: "Mes | Meses",
  days: "Día | Días",
  hours: "Hora | Horas",
  minutes: "Minuto | Minutos",
  seconds: "Segundo | Segundos",
  apply: "Aplicar",
  userCreated: "El usuario se ha creado",
  changesSaved: "Cambios guardados correctamente",
  confirm: "Confirmar",
  confirmDeleteUser: "Confirme que desea eliminar al usuario {name}",
  editAppSettings: "Editar configuración de la aplicación",
  accessibleBy: "Accesible para:",
  discard: "Descartar",
  editAsset: "Editar activo",
  creatingAssetTemplate: "Creando plantilla de activo",
  createTemplate: "Crear plantilla",
  templateName: "Nombre de la plantilla de activo",
  create: "Crear",
  addField: "Añadir campo",
  fields: "Campos",
  description: "Descripción",
  text: "Texto",
  select: "Selección",
  number: "Número",
  createField: "Crear campo",
  selectionOptions: "Opciones",
  editSelectionOptions: "Editar opciones",
  createSelectionOptions: "Crear opciones",
  options: "Opciones",
  add: "Añadir",
  templateManagement: "Gestión de plantillas",
  editAssetTemplate: "Editar plantilla del activo {name}",
  assets: "Activos",
  showInTable: "Visible en la tabla",
  createdAt: "Fecha de creación",
  created: "Creado",
  lastEdit: "Última edición",
  saveAndCreateAnother: "Guardar y crear otra entrada",
  entryAdded: "Entrada añadida",
  title: "Título",
  link: "Enlace",
  image: "Imagen",
  appsAdmin: "Administración de aplicaciones",
  createApp: "Crear aplicación",
  defaultLanguage: "Idioma predeterminado",
  translations: "Traducciones",
  translation: "Traducción",
  translationsSaved: "Traducciones guardadas correctamente.",
  translationEditingDisabled:
    "Su idioma ({userLanguage}) es distinto del idioma del gemelo digital ({twinLanguage}). Use las traducciones para editar el texto localizado.",
  propertyCreationLanguageWarning:
    "Su idioma ({userLanguage}) es distinto del idioma del gemelo digital ({twinLanguage}). El nombre y la descripción se guardan como traducciones en {twinLanguage}.",
  defaultTranslationsRequired:
    "Las traducciones predeterminadas no pueden estar vacías.",
  noRoles: "No hay roles",
  noTwinTemplatesExist: "Todavía no se han creado plantillas.",
  properties: "Propiedades",
  selectProperty: "Seleccionar propiedad",
  addProperty: "Añadir propiedad",
  refreshInterval: "Intervalo de actualización",
  assetManagement: "Gestión de activos",
  yes: "Sí",
  no: "No",
  active: "Activo",
  noActiveVersion: "No hay ninguna versión activa",
  hierarchy: "Jerarquía",
  back: "Volver",
  changelog: "Registro de cambios",
  changelogDescription:
    "Registro de todas las entradas y salidas de mercancías del almacén.",
  changeType: "Tipo de cambio",
  changedAt: "Fecha del cambio",
  changedBy: "Modificado por",
  changedReason: "Motivo del cambio",
  assetCreated: "Activo creado",
  propertyChanges: "Cambios",
  id: "ID",
  reports: "Informes",
  twinReportGroups: "Grupos de informes",
  twinReportSettings: "Configuración de informes",
  twinReportSelectGroupFirst: "Seleccione primero un grupo",
  twinReportSettingSelect: "Seleccionar configuración",
  twinReportPrefix: "Prefijo del tipo",
  twinReportPropertyFilterCustomIds: "Filtrar propiedades",
  twinReportReturnProperties: "Propiedades del resultado",
  twinReportId: "ID",
  twinReportFixedFilterValues: "Valores de filtro fijos",
  twinReportValuesCommaSeparated: "Valores separados por comas",
  twinReportSettingNameExplanation:
    "Nombre interno único para esta configuración de informe",
  twinReportLabelExplanation:
    "Nombre mostrado como título de la pestaña del informe",
  twinReportTypeExplanation:
    "Define qué tipos de gemelo digital se incluyen mediante un prefijo de tipo. Seleccione una plantilla o introduzca un prefijo manualmente.",
  twinReportFixedFiltersExplanation:
    "Estos filtros se aplican siempre. Los usuarios no pueden modificarlos.",
  twinReportUserFiltersExplanation:
    "Estos controles de filtro se muestran a los usuarios en la interfaz del informe.",
  twinReportColumnsExplanation:
    "Estas columnas aparecen en la tabla de resultados del informe.",
  twinReportSelectOrTypePrefixHint:
    "Seleccione una plantilla o introduzca un prefijo de tipo",
  assetReports: "Informes de activos",
  assetChangelog: "Registros de cambios de activos",
  assetReportsDescription:
    "Resumen de todos los activos y su documentación, agrupados por tipo de activo",
  assetChangelogReportsDescription:
    "Lista de cambios en la documentación de activos para el intervalo de tiempo seleccionado",
  show: "Mostrar",
  export: "Exportar",
  filter: "Filtrar",
  edit: "Editar",
  documents: "Documentos",
  addImages: "Arrastre y suelte o haga clic aquí para añadir imágenes",
  dropFilesHere: "Suelte los archivos aquí",
  uploadDocument: "Cargar documento",
  file: "Archivo",
  selectFile: "Seleccionar archivo",
  noFileSelected: "No se ha seleccionado ningún archivo",
  editDocument: "Editar documento",
  assetType: "Tipo",
  firstName: "Nombre",
  lastName: "Apellido",
  manageInputValues: "Gestionar valores de entrada",
  inputValues: "Valores de entrada",
  instances: "Instancias",
  mandatory: "Obligatorio",
  relation: "Relación",
  selectMultiple: "Selección múltiple",
  noValues: "Actualmente no hay valores",
  noData: "No hay datos",
  followingFieldsAreRequired: "Los siguientes campos son obligatorios",
  fillInAllRequiredFields: "Rellene todos los campos obligatorios",
  category: "Categoría",
  changesStartDate: "Cambios desde",
  changesEndDate: "Cambios hasta",
  clickOnShowToViewData: "Haga clic en {0} para ver los datos",
  results: "Resultados",
  addRelation: "Añadir relación",
  relations: "Relaciones",
  addItem: "Añadir {item}",
  editItem: "Editar {item}",
  date: "Fecha",
  year: "Año",
  yesNo: "Sí/No",
  pleaseEnterItem: "Introduzca {item} para continuar.",
  itemAlreadyExists: "Esta entrada ya existe",
  usedAsFilterIn: "Se utiliza como filtro para:",
  confirmDeleteValueList:
    "{valueList} podría utilizarse como filtro. Si se elimina {valueList}, también se eliminarán todos los valores asociados.",
  selectFilterFirst: "Seleccione primero {filter}",
  propertyDeleteNotAvailableDueToFilteredValues:
    "No se puede eliminar {property} porque se utiliza como filtro para {filteredProperties}.\n\nElimine primero estos campos",
  spareParts: "Repuestos",
  settings: "Configuración",
  myAccount: "Mi cuenta",
  myData: "Datos del perfil",
  changePassword: "Cambiar contraseña",
  repeatPassword: "Repetir contraseña",
  passwordChanged: "Contraseña cambiada correctamente.",
  passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
  passwordsDontMatch: "Las contraseñas introducidas no coinciden",
  articles: "Artículos",
  singleArticles: "Artículos individuales",
  createArticle: "Crear artículo",
  quantityArticle: "Artículo por cantidad",
  singleArticleDescription:
    "Artículos gestionados por separado como unidades individuales, por ejemplo, artículos grandes como repuestos",
  quantityArticleDescription:
    "Artículos gestionados por cantidad, como líquidos medidos en litros o tornillos por peso",
  editable: "Editable",
  handout: "Entrega",
  refill: "Reposición",
  transport: "Transporte",
  inventory: "Inventario",
  amount: "Cantidad",
  comment: "Comentario",
  warehouse: "Almacén",
  components: "Componentes",
  references: "Referencias",
  handoutToUser: "Entregado a",
  storageLocation: "Ubicación de almacenamiento",
  articleDocumentedCorrectly:
    "La cantidad del artículo en la ubicación registrada es correcta",
  articleInventoryDifference: "La cantidad no coincide",
  actualInventory: "Cantidad real",
  reason: "Motivo",
  articleDoesNotExist: "El artículo no existe",
  group: "Grupo",
  groups: "Grupos",
  accessRights: "Permisos de acceso",
  accessRightsWarehouse: "Permisos de acceso al almacén",
  createGroup: "Crear grupo",
  targetAndSourceAreSame: "La ubicación de origen y destino es la misma",
  systemMisconfigured:
    "Hay un error en la configuración del sistema. Póngase en contacto con el administrador del sistema.",
  ticketViewMissingCustomIds:
    "La vista de tickets requiere los siguientes ID personalizados:",
  editableOnCreate: "Editable al crear",
  warehouseManager: "Responsable del almacén",
  warehouseInfo: "Información del almacén",
  done: "Hecho",
  customId: "ID personalizado",
  all: "Todo",
  userCreatableEntriesForInputValues:
    "Los usuarios pueden añadir opciones dinámicamente",
  inventoryManagement: "Gestión de inventario",
  articleSearch: "Buscar artículos",
  addNomenclature: "Añadir nomenclatura",
  createUser: "Crear usuario",
  userExists:
    "Ya existe un usuario con ese nombre de usuario o correo electrónico",
  myTickets: "Mis tickets",
  ticketsAssignedToMe: "Tickets asignados a mí",
  priority: "Prioridad",
  plannedFinish: "Finalización prevista",
  firstPlannedFinish: "Primera finalización prevista",
  createdBy: "Creado por",
  assignee: "Asignado a",
  comments: "Comentarios",
  send: "Enviar",
  low: "Baja",
  medium: "Media",
  high: "Alta",
  loadPreviousComments: "Cargar comentarios anteriores",
  createTicket: "Crear ticket",
  files: "Archivos",
  noFiles: "No hay archivos",
  noRelations: "No hay relaciones",
  requester: "Solicitante",
  takeInProcess: "Procesar",
  reject: "Rechazar",
  complete: "Completar",
  validate: "Validar",
  invalidate: "Invalidar",
  longComment: "Detalles",
  createDraft: "Crear borrador",
  submitDraft: "Enviar borrador",
  draft: "Borrador",
  submit: "Enviar",
  rejected: "Rechazado",
  new: "Nuevo",
  "in process": "En curso",
  completed: "Completado",
  notCompleted: "No completado",
  confirmed: "Confirmado",
  plan: "Plan",
  planned: "Planificado",
  reopen: "Reabrir",
  myRequests: "Mis solicitudes",
  assignedToMe: "Asignado a mí",
  assetManager: "Responsable de activos",
  assetInfo: "Información del activo",
  maintenance: "Mantenimiento",
  asset: "Activo",
  location: "Ubicación",
  assetOrLocation: "Activo o ubicación",
  reportedBy: "Notificado por",
  damageDescription: "Descripción de la avería",
  workCarriedOut: "Trabajo realizado",
  ticketAdmin: "Gestión de tickets",
  sopManagement: "Gestión de tareas",
  enterWorkCarriedOutBeforeCompleting:
    "Introduzca el trabajo realizado antes de completar el ticket.",
  enterWorkDurationBeforeCompleting:
    "Introduzca la duración del trabajo antes de completar el ticket.",
  createPlan: "Crear plan",
  repetition: "Repetición",
  createMaintenancePlan: "Crear plan de mantenimiento",
  editMaintenancePlan: "Editar plan de mantenimiento",
  leadDuration: "Antelación",
  sop: "Tareas",
  createSop: "Crear tareas",
  maintenancePlans: "Planes de mantenimiento",
  timespan: "Periodo",
  firstActivation: "Primera activación",
  leadDurationDescription:
    "Antelación con la que debe crearse el ticket antes de la fecha de finalización prevista. Por ejemplo, si se establece en un mes, el ticket de este proceso de mantenimiento se creará un mes antes de la fecha de vencimiento.",
  ticketName: "Nombre del ticket",
  ticketDescription: "Descripción del ticket",
  confirmDeleteMaintenancePlan:
    "Confirme que desea eliminar el plan de mantenimiento {name}",
  addSop: "Añadir tarea",
  addChecklist: "Añadir lista de comprobación",
  checklistName: "Nombre de la lista de comprobación",
  addEntry: "Añadir entrada",
  checklist: "Lista de comprobación",
  createTicketForTask: "Crear un ticket para esta tarea",
  ticketTemplate: "Plantilla de ticket",
  transferToTicket: "Transferir al ticket",
  sops: "Tareas",
  tasks: "Tareas",
  addMaterial: "Añadir material",
  materialUse: "Uso de material",
  feedback: "Comentarios",
  completeTodoListItem: "Completar elemento de la lista de tareas",
  itemsAvailable: "{items} disponibles",
  createSopVersion: "Añadir versión de tareas",
  manageSopVersions: "Gestionar versiones de tareas",
  firstActivatedAt: "Primera activación",
  activation: "Activación",
  confirmActivateVersion: "Confirme que desea {0} {1}",
  activateSopVersion: "Activar versión de tareas",
  deactivateSopVersion: "Desactivar versión de tareas",
  activate: "Activar",
  deactivate: "Desactivar",
  activateAll: "Activar todo",
  deactivateAll: "Desactivar todo",
  editSop: "Editar tareas {name}",
  completionTracking: "Seguimiento de finalización",
  createTask: "Crear tarea",
  tasklist: "Lista de tareas",
  task: "Tarea",
  sopNotEditable:
    "Estas tareas no se pueden editar porque ya se han utilizado. Para editarlas, cree una versión nueva.",
  editTask: "Editar tarea",
  version: "Versión",
  versionActivated: "Versión activada",
  versionDeactivated: "Versión desactivada",
  nOfMTasksCompleted: "({n}/{m}) tareas completadas",
  Permission: "Permiso",
  Permissions: "Permisos",
  UniqueID: "ID único",
  Accesstype: "Tipo de acceso",
  writeAccess: "escritura",
  readAccess: "lectura",
  chooseDifferentArticle: "Elegir otro artículo",
  removeArticleFromWarehouse: "Eliminar este artículo del almacén",
  errorRemovingArticleFromWarehouse:
    "No se pudo eliminar el artículo del almacén. Vaya al almacén y registre la entrega.",
  damageNotice: "Informe de daños",
  ticketType: "Tipo de ticket",
  ticketNumber: "N.º de ticket",
  qmdocuments: "Documentos de gestión de calidad",
  customer: "Cliente",
  addDocument: "Añadir documento",
  inProcess: "En curso",
  atCustomer: "En el cliente",
  finished: "Finalizado",
  accepted: "Aceptado",
  content: "Contenido",
  proposal: "Contenido propuesto",
  dataSources: "Fuentes de datos",
  accept: "Aceptar",
  rewrite: "Reescribir",
  filename: "Nombre del archivo",
  itAssets: "Activos de TI",
  itAssetChangelog: "Registro de cambios de activos de TI",
  inspection: "Inspección",
  itAssetManager: "Responsable de activos de TI",
  itAssetInfo: "Información del activo de TI",
  maintenancePlanNotEditable:
    "Este plan de mantenimiento no se puede editar mientras esté activo.",
  upload: "Cargar",
  downloadTemplate: "Descargar plantilla",
  uploadCompleted: "Carga completada",
  csvUploadValuesMustMatchTemplate:
    "La lista de valores debe coincidir con la plantilla descargable.",
  csvUploadSeparatorMustBeSemicolon:
    "El carácter separador debe ser un punto y coma (;).",
  csvUploadEncodingMustBeUtf8:
    "El archivo CSV debe estar codificado en UTF-8 sin formato.",
  csvUploadMustNotEndWithEmptyLine:
    "El archivo CSV no debe terminar con una línea vacía.",
  csvUploadSemicolonValuesMustBeQuoted:
    'Los valores que contengan un punto y coma (;) deben ir entre comillas, por ejemplo, "G 1 T 37;1".',
  maintenancePlanStartDateHasToBeInTheFutureToActivate:
    "La fecha de vencimiento debe ser futura para poder activar un plan",
  paragraphs: "Párrafos",
  addParagraph: "Añadir párrafo",
  processing: "Procesando...",
  proposedContent: "Contenido propuesto",
  sentenceDetails: "Detalles",
  addCustomContentProposal: "Añadir contenido personalizado",
  addContentAndAccept: "Añadir propuesta de contenido",
  useProposedContent: "Usar propuesta",
  groupManagement: "Gestión de grupos",
  permissions: "Permisos",
  permission: "Permiso",
  appRoles: "Roles de la aplicación",
  label: "Etiqueta",
  path: "Ruta",
  protocol: "Protocolo",
  selection: "Selección",
  addPermission: "Añadir permiso",
  clientId: "ID de cliente",
  howSatisfiedAreYouWithTheProposal:
    "¿Qué grado de satisfacción tiene con la propuesta?",
  unsatisfied: "Insatisfecho",
  notSatisfied: "No satisfecho",
  mostlySatisfied: "Bastante satisfecho",
  satisfied: "Satisfecho",
  verySatisfied: "Muy satisfecho",
  editParagraph: "Editar párrafo",
  editParagraphWarning:
    "Al editar el párrafo completo, se perderán todos los cambios actuales en las frases.",
  addRoles: "Añadir roles",
  addCustomerResponse: "Añadir respuesta del cliente",
  editedVersion: "Versión editada",
  similarSnippets: "Fragmentos similares",
  suggestion: "Sugerencia",
  document: "Documento",
  customerResponse: "Respuesta del cliente",
  declined: "Rechazado",
  confirmDeleteItem: "Confirme que desea eliminar {item}.",
  noSuggestion: "No hay sugerencias",
  categories: "Categorías",
  DE: "Alemán",
  EN: "Inglés",
  createTranslation: "Crear traducción",
  createTopic: "Crear tema",
  editCategoryName: "Editar categoría {name}",
  default: "Predeterminado",
  topic: "Tema",
  categoryIsAlreadyInUse:
    "No se puede eliminar la categoría porque ya está en uso",
  warehouseTransfer: "Traslado entre almacenes",
  constraint: "Restricción",
  single: "Individual",
  multiple: "Múltiple",
  template: "Plantilla",
  calendar: "Calendario",
  duration: "Duración",
  workDuration: "Duración del trabajo",
  cloneTemplate: "Duplicar plantilla",
  confirmCloneTemplate: "¿Seguro que desea duplicar la plantilla {name}?",
  ticketSearch: "Búsqueda de tickets",
  onlyImagesAreAllowed: "Solo se permite cargar imágenes",
  errorUpdatingPassword: "Error al actualizar la contraseña",
  technicalSpecificationsAndEquipmentEngineeringDocuments:
    "Especificaciones técnicas y documentos de ingeniería de equipos",
  equipmentLifecycleDocumentationAndMaintenanceRecords:
    "Documentación del ciclo de vida de los equipos y registros de mantenimiento",
  moveToName: "Mover a {name}",
  refresh: "Actualizar",
  responsibility: "Responsabilidad",
  causeCategory: "Categoría de causa",
  saveMultipleInstances: "Crear varias instancias",
  chooseAmountOfInstances: "Elija cuántas instancias desea crear",
  nOfmInstancesCreated: "{n} de {m} instancias creadas",
  machineRestrictions: "Restricciones de máquina",
  install: "Instalar",
  field: "Campo",
  value: "Valor",
  visible: "Visible",
  editProperty: "Editar propiedad",
  machineRestrictionCreateDialogDescription:
    "Las restricciones de máquina limitan los valores de entrada de una plantilla en una máquina. Seleccione la plantilla cuyas entradas desea restringir.",
  hidden: "Oculto",
  locked: "Bloqueado",
  editMachineRestrictionName: "Editar restricción de máquina {name}",
  createMachineRestriction: "Crear restricción de máquina",
  installedOnTheDevice: "Instalado en este dispositivo",
  uninstall: "Desinstalar",
  replaceMachineRestriction: "Sustituir restricción de máquina",
  replaceMachineRestrictionDetails:
    "Al instalar la restricción de máquina {newName}, se sustituirá la restricción de máquina {oldName} existente en esta máquina.",
  german: "Alemán",
  english: "Inglés",
  spanish: "Español",
  qrCodeOutdated: "Este código QR ya no está activo",
  sopActivationExplanation:
    "Al activar una versión de tareas, su contenido actual queda fijado y ya no se puede editar. Si necesita hacer cambios, debe crear una versión nueva. Solo se pueden seleccionar versiones activas en la configuración de los planes de mantenimiento.",
  interventionPeriod: "Periodo de intervención",
  images: "Imágenes",
  noImages: "No hay imágenes",
  notFound: "Esta página no existe",
  accessDenied: "Acceso denegado",
  apps: "Aplicaciones",
  dashboard: "Panel",
  dashboards: "Paneles",
  dashboardsComingSoon: "Los paneles estarán disponibles próximamente.",
  assetDashboard: "Panel de activos",
  availability: "Disponibilidad",
  mtbf: "MTBF",
  mtbfLong: "Tiempo medio entre fallos",
  mttr: "MTTR",
  mttrLong: "Tiempo medio de reparación",
  maintenanceRatio: "Ratio de mantenimiento",
  preventive: "Preventivo",
  corrective: "Correctivo",
  spindleTemperature: "Temperatura del husillo",
  vibration: "Vibración",
  powerConsumption: "Consumo de energía",
  last7Days: "Últimos 7 días",
  warningThreshold: "Advertencia",
  limitThreshold: "Límite",
  hybridProductionTitle: "Producción híbrida e índices financieros",
  liveTelemetrySapCo: "Telemetría en tiempo real y SAP CO",
  oeeFinancialized: "OEE (con valoración financiera)",
  oeeDescription:
    "Combina disponibilidad, rendimiento y calidad. Relación directa con los costes generales no absorbidos.",
  optimalRuntime: "Tiempo de funcionamiento óptimo",
  optimalRuntimeDescription:
    "Proporción del tiempo de funcionamiento al tiempo de ciclo teórico máximo. Los descensos indican pérdidas de margen.",
  throughputPpm: "Rendimiento (PPM)",
  throughputDescription:
    "Piezas por minuto. Una velocidad alta reduce directamente los costes fijos de fabricación por unidad.",
  firstPassYield: "Rendimiento a la primera (FPY)",
  firstPassYieldDescription:
    "Indicador de calidad. Un FPY alto elimina los costes de desechos y el esfuerzo de reprocesamiento.",
  maintenanceCostPerUnit: "Coste de mantenimiento por unidad",
  maintenanceCostDescription:
    "Indicador operativo clave. Se obtiene directamente del Diario Universal de SAP.",
  maintenanceCostRatio: "MC / VR",
  maintenanceCostRatioDescription:
    "Costes de mantenimiento frente al valor de reposición estimado. Justifica una nueva inversión de capital frente a las reparaciones.",
  mtbfDescription:
    "Tiempo medio de funcionamiento entre fallos. La previsibilidad garantiza el cumplimiento del programa de producción.",
  preventiveCompliance: "Cumplimiento preventivo",
  preventiveComplianceDescription:
    "Indicador adelantado. Un alto cumplimiento está estrechamente relacionado con la ausencia de fallos catastróficos.",
  perMinute: "/ min",
  hoursUnit: "h",
  addDashboard: "Añadir panel",
  noDashboardsYet: "Todavía no hay paneles",
  noDashboardsYetDescription:
    "Cree su primer panel para visualizar y supervisar sus datos.",
  createFirstDashboard: "Crear primer panel",
  dashboardTitle: "Título del panel",
  dashboardCreated: "Panel creado correctamente",
  dashboardSettingsSaved: "Configuración del panel guardada",
  failedToLoadDashboard: "No se pudo cargar el panel",
  failedToSaveSettings: "No se pudo guardar la configuración",
  noDashboardItems: "Todavía no hay elementos en el panel",
  addDashboardItem: "Añadir elemento al panel",
  selectItemTypePrompt: "Seleccione el tipo de elemento que desea añadir:",
  twinTextOverview: "Resumen de texto del gemelo digital",
  twinTextOverviewDescription:
    "Mostrar las propiedades del gemelo digital en formato de texto",
  richText: "Texto",
  richTextDescription: "Mostrar texto estático",
  richTextContentPlaceholder: "Introduzca texto...",
  textSize: "Tamaño del texto",
  textColor: "Color del texto",
  backgroundColor: "Color de fondo",
  imageDashboardItem: "Imagen",
  imageDashboardItemDescription: "Mostrar una imagen cargada",
  selectImage: "Seleccionar imagen",
  replaceImage: "Sustituir imagen",
  imageUnavailable: "No se ha seleccionado ninguna imagen",
  objectFit: "Ajuste de imagen",
  objectFitContain: "Contener",
  objectFitCover: "Cubrir",
  failedToDeleteImageDocument: "No se pudo eliminar el documento de imagen",
  dqKpiPercentage: "Porcentaje de KPI de calidad de datos",
  dqKpiPercentageDescription:
    "Mostrar los errores de calidad de datos como porcentaje",
  dqKpiTotal: "Total de KPI de calidad de datos",
  dqKpiTotalDescription: "Mostrar el total de errores de calidad de datos",
  dqAnomalousEntries: "Entradas anómalas de calidad de datos",
  dqAnomalousEntriesDescription:
    "Mostrar entradas anómalas para un campo de base de datos",
  itemCreatedSuccessfully: "Elemento creado correctamente",
  failedToCreateItem: "No se pudo crear el elemento",
  itemDeletedSuccessfully: "Elemento eliminado correctamente",
  failedToDeleteItem: "No se pudo eliminar el elemento",
  itemUpdatedSuccessfully: "Elemento actualizado correctamente",
  failedToUpdateItem: "No se pudo actualizar el elemento",
  deleteItem: "Eliminar elemento",
  failedToSaveLayoutChanges: "No se pudieron guardar los cambios de diseño",
  gridSize: "Columnas × Filas",
  gridMargin: "Margen X × Y",
  gridMinSize: "Tamaño mínimo A × H",
  fixedSize: "Ancho × Alto",
  marginX: "Margen X",
  marginY: "Margen Y",
  minWidth: "Ancho mínimo",
  minHeight: "Alto mínimo",
  fixedWidth: "Ancho fijo",
  fixedHeight: "Alto fijo",
  selectPurpose: "Seleccionar propósito",
  dataQuality: "Calidad de datos",
  maintenanceOverview: "Resumen de mantenimiento",
  tmAggregateBarChart: "Agregación de tickets",
  tmAggregateBarChartDescription:
    "Gráfico de barras agrupado por una propiedad del ticket",
  tmTimeAggregateBarChart: "Cronología de tickets",
  tmTimeAggregateBarChartDescription:
    "Recuento de tickets por intervalos de tiempo",
  aggregationProperty: "Agrupar por",
  statusTransitionValue: "Estado",
  statusTransitionMode: "Modo",
  bucketSize: "Tamaño del intervalo",
  addFilter: "Añadir filtro",
  filters: "Filtros",
  fixedFilters: "Filtros",
  filterCustomId: "Propiedad",
  filterValues: "Valores",
  current: "Actual",
  transitioned: "Con transición",
  quarter: "Trimestre",
  week: "Semana",
  timeframe: "Periodo",
  lastWeek: "Semana pasada",
  lastMonth: "Mes pasado",
  lastQuarter: "Trimestre pasado",
  lastYear: "Año pasado",
  timeframeLast12Months: "Últimos 12 meses",
  timeframeLastQuarter: "Último trimestre",
  timeframeLast30Days: "Últimos 30 días",
  timeframeLast7Days: "Últimos 7 días",
  timeframeYearToDate: "Desde el inicio del año",
  timeframePreviousYear: "Año anterior",
  bucketQuarter: "Trimestre",
  bucketMonth: "Mes",
  bucketWeek: "Semana",
  bucketDay: "Día",
  chartLoadError: "No se pudieron cargar los datos del gráfico",
  layoutSettings: "Configuración del diseño",
  sizeMode: "Modo de tamaño",
  fullWidth: "Ancho completo",
  fullHeight: "Alto completo",
  auto: "Automático",
  fixed: "Fijo",
  scroll: "Desplazamiento",
  kiosk: "Quiosco / pantalla completa",
  layoutMode: "Modo de diseño",
  gridRowHeight: "Altura de fila (px)",
  verticalCompact: "Compactar verticalmente",
  sizeModeScrollDescription:
    "Altura de fila fija; el contenido se desplaza verticalmente.",
  sizeModeFullWidthDescription:
    "Siempre ocupa todo el ancho de la ventana gráfica y permite el desplazamiento vertical.",
  sizeModeFullHeightDescription:
    "Se ajusta exactamente a la altura de la pantalla; ideal para pantallas murales y quioscos.",
  sizeModeFixedDescription:
    "Dimensiones exactas en píxeles para el ancho y el alto.",
  general: "General",
  deleteDashboard: "Eliminar panel",
  confirmDeleteDashboard:
    "¿Realmente desea eliminar este panel? Esta acción no se puede deshacer.",
  dashboardDeleted: "Panel eliminado correctamente",
  failedToDeleteDashboard: "No se pudo eliminar el panel",
  thisUserHasNoApps:
    "Este usuario no tiene acceso actualmente a ninguna aplicación.",
  notifications: "Notificaciones",
  notification: "Notificación",
  addSubscription: "Añadir suscripción",
  subscribers: "Suscriptores",
  subscriptionAdded: "Suscripción añadida",
  subscriptionRemoved: "Suscripción eliminada",
  subscriptionUpdated: "Suscripción actualizada",
  noEventsInThisApp: "Esta aplicación no admite notificaciones",
  groupAlreadySubscribed: "Este grupo ya está suscrito",
  subscribe: "Suscribirse",
  currentlyNoSubscriptions:
    "Esta notificación no tiene suscriptores. Haga clic en {0} para añadirlos.",
  contacts: "Contactos",
  countryCode: "Código de país",
  phoneNumber: "Número de teléfono",
  street: "Calle",
  numberShort: "N.º",
  areaCode: "Código postal",
  city: "Ciudad",
  country: "País",
  address: "Dirección",
  addEmail: "Añadir correo electrónico",
  addAddress: "Añadir dirección",
  addPhone: "Añadir número de teléfono",
  contributors: "Colaboradores",
  contributing: "Colaborando",
  andNMore: "+{n} más",
  endEdit: "Finalizar edición",
  addContact: "Añadir contacto",
  company: "Empresa",
  person: "Persona",
  attachments: "Archivos adjuntos",
  editSubscription: "Editar suscripción",
  registrationNumber: "Número de registro",
  vatId: "NIF-IVA",
  userInformation: "Información del usuario",
  plannedFinishDescription:
    "Finalización prevista del mantenimiento. La fecha se utilizará como fecha de finalización del mantenimiento en el calendario. Los próximos tickets se crearán después de la finalización prevista, según la repetición {repetition}",
  plannedStart: "Inicio previsto",
  plannedDuration: "Duración prevista",
  to: "a",
  ticketHistory: "Cronología del ticket",
  commented: "Comentó",
  editedBy: "Editado por",
  newComment: "Nuevo comentario",
  deletedBy: "Eliminado por",
  changedTo: "cambió a",
  hasAddedrelationToValue: "añadió una relación con {value}",
  hasDeletedRelationToValue: "eliminó una relación con {value}",
  hasAddedDocumentName: "añadió el documento {name}",
  hasDeletedDocumentName: "eliminó el documento {name}",
  hasAddedImage: "añadió una imagen",
  hasDeletedImage: "eliminó una imagen",
  oee: "OEE",
  outdatedVersionReloadPage:
    "Está usando una versión obsoleta. Haga clic aquí para actualizar la página y cargar la nueva versión.",
  confirmRemoveUserFromGroup:
    "¿Seguro que desea eliminar al usuario del grupo {name}?",
  addGroup: "Añadir grupo",
  hasAddedSopName: "añadió las tareas {name}",
  hasDeletedSopName: "eliminó las tareas {name}",
  hasAddedSopInstanceName: "añadió una instancia de tarea {name}",
  hasDeletedSopInstanceName: "eliminó una instancia de tarea {name}",
  hasAddedTasklistName: "añadió la lista de tareas {name}",
  hasDeletedTasklistName: "eliminó la lista de tareas {name}",
  hasUpdatedTasklistName: "actualizó la lista de tareas {name}",
  hasAddedTasklistItemIn: "añadió un elemento en {name}",
  hasDeletedTasklistItemIn: "eliminó un elemento de {name}",
  hasUpdatedTasklistItemIn: "actualizó un elemento en {name}",
  commentUpdated: "Comentario actualizado",
  commentDeleted: "Comentario eliminado",
  editOriginal: "Editar original",
  contactCreatedButCompanyRelationNotCreated:
    "Se creó el contacto, pero no se pudo asociar a la empresa. Intente asociar el contacto a la empresa de nuevo.",
  maintenancePlan: "Plan de mantenimiento",
  addCompany: "Añadir empresa",
  hasSetNameToValue: "estableció {name} como {value}",
  hasChangedNameFromOldValueToNewValue:
    "cambió {name} de {oldValue} a {newValue}",
  removed: "eliminado",
  hasAddedMaterialComsumptionName: "añadió {name} como consumo de material",
  thisTwinHasNoLifecycleData:
    "Este objeto no tiene historial. Esto ocurre con los objetos creados antes de marzo de 2025.",
  changelogs: "Registros de cambios",
  addDocuments: "Añadir documentos",
  knowledgeSpaces: "Espacios de conocimiento",
  addKnowledgeSpace: "Añadir espacio de conocimiento",
  knowledgeDocuments: "Documentos de conocimiento",
  users: "Usuarios",
  confirmYouWantToRemoveNameFromSpace:
    "Confirme que desea eliminar {name} de {space}",
  addFilesDialogHelper:
    "Use el área de arrastrar y soltar o haga clic para añadir archivos. Se cargarán al hacer clic en el botón de carga.",
  documentsAlreadyInList:
    "No se añadieron los siguientes documentos porque ya están en la lista: {names}",
  targetUnitRequiredForFiles:
    "Debe seleccionar una unidad de conocimiento de destino para los siguientes archivos: {names}",
  duplicateNewVersionOfTarget:
    "La siguiente unidad de conocimiento se seleccionó más de una vez como destino de «Nueva versión de»: {names}",
  namelessDocument: "Documento sin nombre",
  chats: "Chats",
  addChat: "Hacer una pregunta",
  moreOptions: "Más opciones",
  dateRange: "Intervalo de fechas",
  typeAMessage: "Escriba una pregunta...",
  knowledgeSpace: "Espacio de conocimiento | Espacios de conocimiento",
  question: "Pregunta",
  chat: "Chat",
  knowledgeUnits: "Base de conocimiento",
  startNewChat: "Iniciar un chat nuevo",
  errorLoadingMessages:
    "Error al cargar los mensajes anteriores. Aún puede hacer preguntas nuevas.",
  summary: "Resumen",
  member: "Miembro",
  steward: "Responsable",
  owner: "Propietario",
  manageKnowledgeUnits: "Gestionar unidades de conocimiento",
  addKnowledgeUnit: "Añadir unidad de conocimiento",
  withRole: "con el rol",
  uploadDocuments: "Cargar documentos",
  accessToKnowledgeSpaceRevoked:
    "Se ha revocado el acceso al espacio de conocimiento",
  noChats: "Todavía no hay chats",
  noConversations: "No hay conversaciones",
  noConversationsFound: "No se encontraron conversaciones",
  archived: "Archivado",
  open: "Abierto",
  turns: "{count} turnos",
  lastActivity: "Última actividad: {date}",
  confirmRemoveDocumentFromSpace:
    "¿Seguro que desea eliminar el documento de este espacio? El documento seguirá disponible en otros espacios.",
  remove: "Eliminar",
  textOptions: "Opciones de texto",
  maxLength: "Longitud máxima",
  singleLine: "Una línea",
  multiLine: "Varias líneas",
  rows: "Filas",
  aiSearchable: "Visible para la IA",
  clickOrDropHere: "Haga clic o suelte un archivo aquí",
  knowledgeUnitsUsedForReply:
    "Unidades de conocimiento utilizadas para la respuesta",
  changesSavedSuccessfully: "Cambios guardados correctamente",
  thinking: "Pensando...",
  confirmRemoveKnowledgeSpace:
    "¿Seguro que desea eliminar el espacio de conocimiento {spaceName}?",
  createNewKnowledgeUnit: "Crear unidad de conocimiento",
  newVersionOf: "Nueva versión de",
  referenceFor: "Referencia para",
  detectingSimilarUnit: "Detectando unidad similar...",
  targetKnowledgeUnit: "Unidad de conocimiento",
  addExistingKnowledgeUnit: "Añadir unidad de conocimiento existente",
  addUnitsDialogHelp: `Este cuadro de diálogo permite añadir o eliminar unidades de conocimiento existentes del espacio actual.
    Muestra todas las unidades a las que tiene acceso. Use el interruptor de la derecha para añadir o eliminar una unidad de este espacio.`,
  addUnitsDialogHelpExample:
    "Se pueden añadir unidades de uso habitual, como directrices o normativas de toda la empresa.",
  editKnowledgeUnits: "Editar unidades de conocimiento",
  thoughts: "Reflexiones",
  available: "Disponible",
  addNewVersion: "Añadir versión nueva",
  documentDetails: "Detalles del documento",
  versions: "Versiones",
  onlyDocumentsWithStatusDoneCanBeActivated:
    "Esta versión no se puede activar porque aún no se ha procesado",
  thisChatIsBasedOnOutDatedInformation:
    "Este chat se basa en información obsoleta, por lo que no se pueden hacer más preguntas.",
  details: "Detalles",
  section: "Sección",
  errorLoadingSuggestedQuestions:
    "No se pudieron cargar las preguntas sugeridas",
  suggestedQuestions: "Preguntas sugeridas",
  addQuestion: "Añadir pregunta",
  testThisQuestion: "Probar esta pregunta",
  editQuestion: "Editar pregunta",
  createName: "Crear {name}",
  newEntry: "Nueva entrada",
  uploadImage: "Cargar imagen",
  documentUploadedSuccessMessage: "Documento cargado correctamente",
  inactive: "Inactivo",
  automaticCorrection: "Corrección automática",
  generatingCorrection: "Generando corrección",
  automaticServicesUnavailable: "Servicios automatizados no disponibles",
  automaticCorrectionRestart:
    "Error de autocorrección; haga clic para reiniciar",
  automaticCorrectionAvailable: "Corrección automática disponible",
  deleteCorrection: "Eliminar autocorrección",
  saveAutoCorrection: "Guardar autocorrección",
  versionManagement: "Gestión de versiones",
  versionNameActivatedClickHereToViewThisVersion:
    "Versión {name} activada. Haga clic aquí para editar esta versión.",
  retry: "Reintentar",
  deleteSuccess: "Eliminado correctamente",
  exportStarted: "Exportación iniciada",
  exportStartedDescription:
    "Se está preparando la exportación. Puede tardar un poco.",
  maintenanceReports: "Tickets de mantenimiento",
  reportsOverview: "Resumen de informes",
  confirmRemoveKnowledgeUnit:
    "¿Seguro que desea eliminar la unidad de conocimiento {name}?",
  knowledgeUnitCantBeDeletedBecauseItHasBeenActivated:
    "No se puede eliminar esta unidad de conocimiento porque ya se ha activado.",
  databases: "Bases de datos",
  updated: "Actualizado",
  records: "Registros",
  good: "Bueno",
  warning: "Advertencia",
  critical: "Crítico",
  connected: "Conectado",
  tables: "Tablas",
  tickets: "Tickets",
  completeness: "Integridad",
  accuracy: "Precisión",
  consistency: "Coherencia",
  validity: "Validez",
  score: "Puntuación",
  method: "Método",
  scope: "Ámbito",
  llmSearchableWarningMessage:
    "Se ha activado la visibilidad para la IA. Es posible que los campos existentes tarden en procesarse y estar visibles.",
  databaseManagement: "Gestión de bases de datos",
  filePreviewNotSupportedByYourBrowser:
    "Su navegador no admite la vista previa de este archivo",
  databaseConnectionCreated: "Conexión a la base de datos creada",
  databaseConnectionUpdated: "Conexión a la base de datos actualizada",
  databaseConnectionDeleted: "Conexión a la base de datos eliminada",
  databaseConnectionError: "Error al crear la conexión a la base de datos",
  databaseConnectionTested: "Conexión a la base de datos probada correctamente",
  createDatabaseConnection: "Crear conexión a la base de datos",
  editDatabaseConnection: "Editar conexión a la base de datos",
  table: "Tabla",
  databaseConnectionTestError: "Error al probar la conexión a la base de datos",
  testConnection: "Probar conexión",
  databaseConnectionTestSuccess:
    "Prueba de conexión a la base de datos correcta",
  databaseConnectionTestSuccessMessage:
    "Prueba de conexión a la base de datos correcta",
  connectionStatus: "Estado de la conexión",
  connectionError: "Error de conexión",
  goToDatabaseManagement: "Ir a la gestión de bases de datos",
  moreDetails: "Más detalles",
  lessDetails: "Menos detalles",
  sort: "Ordenar",
  scoped: "Ámbitos",
  host: "Servidor",
  port: "Puerto",
  database: "Base de datos",
  redirectingToLogin: "Redirigiendo a la página de inicio de sesión...",
  loggingIn: "Iniciando sesión...",
  errorLoggingIn: "Error al iniciar sesión",
  backToLogin: "Volver al inicio de sesión",
  enabled: "Activado",
  disabled: "Desactivado",
  analysis: "Análisis",
  minScore: "Puntuación mínima",
  maxScore: "Puntuación máxima",
  appIsManaged: "Gestión automática",
  appIsManagedDescription:
    "Gestión automática mediante smx. Si está activada, smx podría sobrescribir cualquier edición.",
  appIconTooLarge:
    "El icono de la aplicación es demasiado grande. El tamaño máximo es de 300 KB.",
  columns: "Columnas",
  update: "Actualizar",
  addNote: "Añadir nota",
  note: "Nota",
  enterNote: "Introduzca una nota...",
  kpiThresholds: "Umbrales",
  start: "Inicio",
  end: "Fin",
  fieldDeactivated: "Campo desactivado",
  fieldDeactivatedDescription:
    "Este campo se ha desactivado y ya no se analiza",
  deactivateFieldExplanation:
    "Al desactivar este campo, se excluirá del análisis y de los informes.",
  downloadExcel: "Descargar Excel",
  more: "Más",
  stop: "Detener",
  downloadDocument: "Descargar documento",
  changes: "Cambios",
  noteSaved: "Nota guardada correctamente",
  schedule: "Programación",
  productionTickets: "Tickets de producción",
  maintenanceTickets: "Tickets de mantenimiento",
  deactivated: "Desactivado",
  anomaliesDashboard: "Panel de anomalías",
  notStartedYet: "Todavía no se ha iniciado",
  createReport: "Crear informe",
  addReport: "Añadir informe",
  twinReportPrefixRequired: "Debe seleccionar una plantilla o un tipo.",
  twinReportIdFilter: "Filtro de ID",
  twinReportModifiedFilter: "Filtro de fecha de modificación",
  twinReportCreatedFilter: "Filtro de fecha de creación",
  twinReportDescription: "Descripción",
  twinReportCreated: "Creado",
  widgetTitleDescription:
    "Título del widget. Si no se especifica, se utilizará el nombre del campo como título.",
  widgetDescriptionDescription:
    "Descripción del widget y de lo que indican las anomalías. Se muestra en el widget.",
  widgetInformationDescription:
    "Información adicional que se muestra como ventana emergente e indica qué puede hacer el usuario cuando vea una anomalía.",
  widgetKpiNameDescription:
    "Nombre del KPI. Si no se especifica, se utilizará el nombre predeterminado del KPI.",
  addReportSheet: "Añadir hoja",
  selectAssetOrType:
    "Determina qué máquinas, activos o dispositivos se incluyen en el informe. La selección puede hacerse mediante una plantilla o introduciendo un tipo. Use el asterisco * como comodín para cualquier letra o número.",
  selectTicketOrType:
    "Determina qué tickets se incluyen en el informe. La selección puede hacerse mediante una plantilla o introduciendo un tipo. Use el asterisco * como comodín para cualquier letra o número.",
  workOrder: "Orden de trabajo",
  workOrders: "Órdenes de trabajo",
  size: "Tamaño",
  uploadFailed: "Error al cargar",
  cancelUploads: "Cancelar cargas",
  cancelUploadsConfirm: "Hay cargas en curso. ¿Desea cancelarlas y cerrar?",
  cancelUploadsYes: "Cancelar cargas",
  cancelUploadsNo: "Seguir cargando",
  dangerousActions: "Acciones peligrosas",
  agentSettings: "Configuración del agente",
  noAgentsAvailable: "No hay agentes disponibles",
  products: "Productos",
  mechanicalAcceptanceReports: "Informes de aceptación mecánica",
  electricalAcceptanceReports: "Informes de aceptación eléctrica",
  technicalData: "Datos técnicos",
  admin: "Administración",
  ticketOrigin: "Ticket principal",
  errorLoadingFiles: "Error al cargar los archivos",
  uploadFiles: "Cargar archivos",
  de: "Alemán",
  en: "Inglés",
  es: "Español",
  discardChanges: "Descartar cambios",
} satisfies typeof import("./en").baseTranslationsEn;
